<template>
  <div>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <div>
      <div
        v-if="!isSeller"
        class="has-background-white-ter is-border-bottom is-padding">
        <div class="field">
          <div class="control">
            <input
              id="selfReminder"
              type="checkbox"
              name="selfReminder"
              v-model="selfReminder"
              class="switch is-success is-rounded">
            <label for="selfReminder">Ce rappel est pour moi</label>
          </div>
        </div>
        <div
          v-if="!selfReminder && !isSeller && userCount > 1"
          class="field">
          <r-label
            :is-required="false"
            :label="'Utilisateur interne'"
            :value="user"
            :for-id="'user'"></r-label>
          <div class="control">
            <multiselect
              v-model="user"
              :placeholder="''"
              id="user"
              :custom-label="val => limitText(`${val.last_name} ${val.first_name}`)"
              :options="users"
              name="user"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              class="multiselect--option-ico">
              <span slot="noResult">Oups! Aucune société trouvée.</span>
              <span slot="noOptions">La liste est vide</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Sélectionnez ou saisissez un utilisateur</span>
            </multiselect>
            <p
              v-if="errors.has('user')"
              class="help is-danger">
              {{ errors.first('user') }}
            </p>
          </div>
        </div>
        <div
          v-else-if="!selfReminder && !isSeller && userCount <= 1"
          class="field">
          Aucun autre utilisateur
        </div>
        <div
          v-if="!selfReminder && isAdmin && isPromoteur"
          class="field">
          <r-label
            :is-required="false"
            :label="'Utilisateur externe'"
            :value="external_user"
            :for-id="'external_user'"></r-label>
          <div class="control">
            <multiselect
              v-model="external_user"
              :placeholder="''"
              id="external_user"
              label="name"
              :options="accounts"
              name="external_user"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              class="multiselect--option-ico">
              <span slot="noResult">Oups! Aucune société trouvée.</span>
              <span slot="noOptions">La liste est vide</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Sélectionnez ou saisissez un utilisateur</span>
            </multiselect>
            <p
              v-if="errors.has('external_user')"
              class="help is-danger">
              {{ errors.first('external_user') }}
            </p>
          </div>
        </div>
      </div>

      <div class="has-background-light is-padding">
        <div class="field columns is-multiline">
          <r-label
            :is-required="false"
            :label="'Programmer rappel dans:'"></r-label>
          <div
            v-for="(elem, index) in reminderSelectData"
            :key="index"
            class="column"
            :class="[index < 2 ? 'is-6' : 'is-4']">
            <div class="field">
              <input
                @click="updateDateFromSelect(elem.label)"
                :id="`${index}-quick`"
                v-model="date"
                :value="elem.value"
                name="typeRdv"
                class="vadCheckradiocase is-primary is-fullwidth"
                type="radio">
              <label
                class="is-minW70p"
                :for="`${index}-quick`">{{ elem.label }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="has-background-white is-border-top is-padding">
        <div class="field">
          <r-label
            :is-required="false"
            :label="'Date du rappel'"
            :for-id="'dateEvent'"></r-label>
          <date-picker
            :id="'dateEvent'"
            :model="date"
            :style-version="2"
            @input="date = $event"
            :field-class="''"
            :input-class="'is-fullwidth'"></date-picker>
        </div>
        <div class="field is-margin-top-small">
          <r-label
            :is-required="false"
            label="PROGRAMMER À UNE HEURE PRÉCISE :"
            :for-id="'dateHourStart'"></r-label>
          <date-picker
            :id="'dateHourStart'"
            @input="dateHourStart = $event"
            :model="dateHourStart"
            :field-class="''"
            :is-hour="true"
            :config="configHour"
            :input-class="'is-fullwidth'"
            :style-version="2"
            :icone-main="'fal fa-clock'"></date-picker>
        </div>
        <div class="field is-margin-top-small">
          <v-input
            id="title"
            :name="'title'"
            @input="val => title = val"
            :model="title"
            :errors-bag="errors"
            v-validate="'min:2'"
            data-vv-value-path="val"
            data-vv-as="Titre du rappel">
            <r-label
              slot="label"
              :is-required="false"
              :label="'Titre du rappel'"
              :value="title"></r-label>
          </v-input>
        </div>
        <div class="field">
          <r-label
            :is-required="false"
            :label="'Ajouter note'"></r-label>
          <div class="control">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="note"
              :from-quickview="true"
              @change="val => note = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless has-background-white">
            </wysiwyg-editor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { concat } from 'lodash'
import moment from 'moment'
const REMINDER_DATE_DATA = {
  today: { value: moment().startOf('day').toISOString(), label: 'Aujourd\'hui' },
  tomorrow: { value: moment().startOf('day').add(1, 'd').toISOString(), label: 'Demain' }
}
const REMINDER_SELECT_DATA = [
  { value: moment().startOf('day').toISOString(), label: 'Aujourd\'hui' },
  { value: moment().startOf('day').add(1, 'd').toISOString(), label: 'Demain' },
  { value: moment().startOf('day').add(1, 'w').toISOString(), label: '1 semaine' },
  { value: moment().startOf('day').add(10, 'd').toISOString(), label: '10 jours' },
  { value: moment().startOf('day').add(1, 'M').toISOString(), label: '1 mois' }
]
export default {
  name: 'ReminderForm',
  props: {
    source: {
      type: Object
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      fromCreated: true,
      reminderDateData: REMINDER_DATE_DATA,
      reminderSelectData: REMINDER_SELECT_DATA,
      loading: false,
      userCount: null,
      users: [],
      accounts: [],
      user: null,
      external_user: null,
      selfReminder: true,
      date: null,
      note: null,
      title: null,
      dateHourStart: moment().hour(8).minute(0).format('HH:mm'),
      configHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        altFormat: 'H:i',
        time_24hr: true
      }
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isManager', 'isSeller', 'isPromoteur']),
    noRedirection () {
      if ('noRedirection' in this.params && this.params.noRedirection) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'external_user' (to) {
      if (to != null) {
        this.user = null
      }
    },
    'user' (to) {
      if (to != null) {
        this.external_user = null
      }
    }
  },
  async created () {
    await this.getAllUsers()
    await this.getAllAccounts()
    this.fromCreated = false
    if (this.source) {
      if (this.source.date) {
        let dateStart = moment.utc(this.source.date).toDate()
        this.date = moment(this.source.date).startOf('day').toISOString()
        this.dateHourStart = moment(dateStart).format('HH:mm')
      } else {
        this.date = moment().add(1, 'day').hours(8).startOf('day').toISOString()
      }
      if (this.source.title) {
        this.title = this.source.title
      }
      if (this.source.note) {
        this.note = this.source.note
      }
      if (this.source.user && this.source.user.pk !== this.currentUser.pk) {
        this.selfReminder = false
        this.user = this.source.user
      }
    } else {
      this.date = moment().add(1, 'day').hours(8).startOf('day').toISOString()
    }
  },
  methods: {
    updateDateFromSelect (label) {
      if (label === "Aujourd'hui") {
        this.dateHourStart = moment().format('HH:mm')
      }
    },
    limitText (text) {
      if (text.length > 20) {
        return text.substring(0, 20) + '...'
      } else return text
    },
    async getUsers (query = null) {
      let params = {
        searchable_name: query
      }
      try {
        let { data } = await this.$api.get(this.$resources.USER, params)
        if (this.fromCreated) {
          this.userCount = data.count
        }
        this.users = data.items
      } catch (err) {
        console.log(err)
      }
    },
    async getAllUsers (page = 1) {
      let query = {
        page
      }
      let { data } = await this.$api.get(this.$resources.USER, query)
      if (page > 1) {
        let totalUser = concat(data.items, this.users)
        this.users = totalUser
      } else {
        this.users = data.items
      }
      if (data.page < data.pages) {
        page++
        await this.getAllUsers(page)
      }
      if (this.fromCreated) {
        this.userCount = this.users.length
      }
    },
    async getAccounts (query) {
      try {
        const { data } = await this.$api.get(this.$resources.ACCOUNT, { name: query })
        this.accounts = data.items
      } catch (e) {
        console.log(e)
      }
    },
    async getAllAccounts (page = 1) {
      let query = {
        page
      }
      let { data } = await this.$api.get(this.$resources.ACCOUNT, query)
      if (page > 1) {
        let totalAccount = concat(data.items, this.accounts)
        this.accounts = totalAccount
      } else {
        this.accounts = data.items
      }
      if (data.page < data.pages) {
        page++
        await this.getAllAccounts(page)
      }
    },
    async submitReminder () {
      this.$store.commit('setQuickviewLoading', true)
      if (!this.dateHourStart) {
        this.$toasted.global.danger('Veuillez renseigner une heure associé au rappel.')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      if (!this.selfReminder && !(this.user || this.external_user)) {
        this.$toasted.global.danger('Veuillez renseigner l\'utilisateur associé au rappel.')
        this.$store.commit('setQuickviewLoading', false)
        return
      }
      if (!this.date) {
        this.$toasted.global.danger('Veuillez renseigner le contact associé au rappel.')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      if (!this.title) {
        this.$toasted.global.danger('Veuillez renseigner un titre associé au rappel.')
        this.$store.commit('setQuickviewLoading', false)
        return
      }
      let startHour = document.querySelector('#dateHourStart div .flatpickr-input').value
      startHour = startHour.split(':')

      let reminder = {}
      if (this.params.contact) {
        reminder.contact = this.params.contact.pk
      }
      if (this.params.contact) {
        reminder.custom_fields = {
          contactPk: this.params.contact.pk,
          contactName: `${this.params.contact.first_name} ${this.params.contact.last_name}`
        }
      } else {
        reminder.custom_fields = {}
      }
      if (!this.selfReminder && this.user != null) {
        reminder.user = this.user.pk
      } else if (!this.selfReminder && this.external_user != null) {
        reminder.user = this.external_user.first_admin.pk
      } else {
        reminder.user = this.currentUser.pk
      }
      if (this.source && 'pk' in this.source) {
        reminder.pk = this.source.pk
      }
      reminder.title = this.title
      reminder.date = moment(this.date).set({ 'hour': startHour[0], 'minute': startHour[1] }).utc().toISOString()
      if (this.note) {
        reminder.note = this.note
      }
      if (this.source && this.source.advLink) {
        reminder.custom_fields.adv_link = this.source.advLink
      }
      if (this.source && this.source.programLink) {
        reminder.custom_fields.program_link = this.source.programLink
      }
      if (this.source && this.source.programName) {
        reminder.custom_fields.program_name = this.source.programName
      }
      if (this.source && this.source.advRef) {
        reminder.custom_fields.adv_ref = this.source.advRef
      }
      // Update ADV Rappel
      if (this.source && this.source.custom_fields) {
        if (this.source && this.source.custom_fields.adv_link) {
          reminder.custom_fields.adv_link = this.source.custom_fields.adv_link
        }
        if (this.source && this.source.custom_fields.program_link) {
          reminder.custom_fields.program_link = this.source.custom_fields.program_link
        }
        if (this.source && this.source.custom_fields.program_name) {
          reminder.custom_fields.program_name = this.source.custom_fields.program_name
        }
        if (this.source && this.source.custom_fields.adv_ref) {
          reminder.custom_fields.adv_ref = this.source.custom_fields.adv_ref
        }
      }
      try {
        let request
        let date
        if (this.source && 'pk' in this.source) {
          request = await this.$api.put(this.$resources.REMINDER, reminder.pk, reminder)
          date = moment(request.data.date)
          let eventPk = reminder.pk
          let newDate = moment(date).format('DD/MM/YYYY')
          let sourceDate = moment(this.source.date).format('DD/MM/YYYY')
          this.$store.commit('removeCalendarEvent', { eventPk, sourceDate, type: 'reminders' })
          this.$store.commit('addCalendarEvent', { event: request.data, key: newDate, type: 'reminders' })
        } else {
          request = await this.$api.post(this.$resources.REMINDER, reminder)
          date = moment(request.data.date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: request.data, key: key, type: 'reminders' })
        }
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        let day = moment(date).format('DD')
        let month = moment(date).format('MM')
        let year = moment(date).format('YYYY')
        if (this.$route.name !== 'ContactRdvs' && !this.noRedirection) {
          this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'reminders' } })
        }
        if (this.source && 'pk' in this.source) {
          this.$toasted.global.success('Rappel modifié.')
        } else {
          this.$toasted.global.success('Rappel créé.')
        }
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      } finally {
        this.$store.commit('setQuickviewLoading', false)
        this.$store.commit('resolveQuickview')
      }
    }
  }
}
</script>
